/* Born of Shadows — Shipping Protection toggle
 * - Adds the protection line automatically (toggle ON by default)
 * - Picks the tier by cart subtotal (excluding protection):
 *     under threshold1 -> tier 1, threshold1 up to threshold2 -> tier 2, threshold2+ -> tier 3
 * - Shopper can switch it off; the choice is stored as a cart attribute
 * - Hides the protection line from the item list and shows it as a toggle row instead
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('bos-sp-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ATTR = 'Shipping Protection';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var tierVariantIds = CFG.tiers.map(function (t) { return Number(t.variantId); });
  var busy = false;
  var lastCart = null;

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, CFG.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isProtection(item) {
    return Number(item.product_id) === Number(CFG.productId) ||
      tierVariantIds.indexOf(Number(item.variant_id)) > -1;
  }

  function isOptedOut(cart) {
    var a = cart && cart.attributes ? cart.attributes[ATTR] : null;
    if (a === 'Declined') return true;
    if (a === 'Added') return false;
    return !CFG.defaultOn;
  }

  function merchSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return (isProtection(item) || item.gift_card) ? sum : sum + item.final_line_price;
    }, 0);
  }

  // physical merchandise only (gift cards never need protection)
  function shippableCount(cart) {
    return cart.items.reduce(function (n, item) {
      return (isProtection(item) || item.gift_card) ? n : n + item.quantity;
    }, 0);
  }

  // everything except the protection line (used for the cart badge)
  function merchCount(cart) {
    return cart.items.reduce(function (n, item) {
      return isProtection(item) ? n : n + item.quantity;
    }, 0);
  }

  function tierFor(subtotal) {
    if (subtotal >= CFG.threshold2) return CFG.tiers[2];
    if (subtotal >= CFG.threshold1) return CFG.tiers[1];
    return CFG.tiers[0];
  }

  function signature(cart) {
    return cart && cart.items ? cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',') : '';
  }

  function protectionLines(cart) {
    return cart.items.filter(isProtection);
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Bring the cart in line with the rules. Resolves with the (possibly updated) cart. */
  function reconcile(cart, forceOn) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var lines = protectionLines(cart);
    var count = shippableCount(cart);
    var wantOn = forceOn === true ? true : forceOn === false ? false : !isOptedOut(cart);
    var updates = {};
    var changed = false;

    if (count === 0 || !wantOn) {
      lines.forEach(function (l) { updates[l.key] = 0; changed = true; });
    } else {
      var target = tierFor(merchSubtotal(cart));
      var keep = null;
      lines.forEach(function (l) {
        if (!keep && Number(l.variant_id) === Number(target.variantId)) {
          keep = l;
          if (l.quantity !== 1) { updates[l.key] = 1; changed = true; }
        } else {
          updates[l.key] = 0; changed = true;
        }
      });
      if (!keep) {
        return (changed ? postJSON('cart/update.js', { updates: updates }) : Promise.resolve(cart))
          .then(function () {
            return postJSON('cart/add.js', { items: [{ id: Number(target.variantId), quantity: 1 }] });
          })
          .then(getCart)
          .catch(function () { return getCart(); });
      }
    }
    if (!changed) return Promise.resolve(cart);
    return postJSON('cart/update.js', { updates: updates }).catch(function () { return getCart(); });
  }

  function setChoice(on) {
    return postJSON('cart/update.js', { attributes: (function () { var o = {}; o[ATTR] = on ? 'Added' : 'Declined'; return o; })() });
  }

  /* ---------- UI ---------- */
  var SHIELD = '<svg class="bos-sp__icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M12 2.8 4.5 5.6v5.9c0 4.6 3.1 8.6 7.5 9.7 4.4-1.1 7.5-5.1 7.5-9.7V5.6L12 2.8Z"/><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="m8.6 12.1 2.4 2.4 4.6-4.8"/></svg>';

  function rowHTML(cart) {
    var on = !isOptedOut(cart);
    var price = tierFor(merchSubtotal(cart)).price;
    return '' +
      '<div class="bos-sp" data-bos-sp>' +
        SHIELD +
        '<div class="bos-sp__text">' +
          '<span class="bos-sp__title">' + escapeHTML(CFG.title) + ' <span class="bos-sp__price">' + money(price) + '</span></span>' +
          '<span class="bos-sp__sub">' + escapeHTML(CFG.subtitle) + '</span>' +
        '</div>' +
        '<label class="bos-switch">' +
          '<input type="checkbox" data-bos-sp-toggle ' + (on ? 'checked' : '') + ' aria-label="' + escapeHTML(CFG.title) + '">' +
          '<span class="bos-switch__track" aria-hidden="true"><span class="bos-switch__thumb"></span></span>' +
        '</label>' +
      '</div>';
  }

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function hideProtectionLines(cart, scope) {
    if (!cart) return;
    cart.items.forEach(function (item, i) {
      if (!isProtection(item)) return;
      var line = i + 1;
      // cart drawer
      scope.querySelectorAll('.cart-items-wrapper .media-link[data-line="' + line + '"]').forEach(function (el) {
        el.classList.add('bos-sp-line');
      });
      // cart page
      var rows = scope.querySelectorAll('[data-cart-items] > tr');
      if (rows[i]) rows[i].classList.add('bos-sp-line');
    });
  }

  function decorate(cart) {
    cart = cart || lastCart;
    if (!cart) return;
    var count = merchCount(cart);
    var shippable = shippableCount(cart);

    // drawer
    var drawer = document.querySelector('[data-drawer-body] .yv-cart-drawer');
    if (drawer) {
      hideProtectionLines(cart, drawer);
      var old = drawer.querySelector('[data-bos-sp]');
      if (old) old.remove();
      if (shippable > 0) {
        var anchor = drawer.querySelector('.bottom-cart-box .cart-listed-new-display') || drawer.querySelector('.bottom-cart-box');
        if (anchor) anchor.insertAdjacentHTML('beforebegin', rowHTML(cart));
      }
    }

    // cart page
    var page = document.querySelector('[data-cart-wrapper]');
    if (page) {
      hideProtectionLines(cart, page);
      var oldP = page.querySelector('[data-bos-sp]');
      if (oldP) oldP.remove();
      if (shippable > 0) {
        var a2 = page.querySelector('.cart-sidebar .cart-btn') || page.querySelector('.cart-sidebar .cart-total-list');
        if (a2) a2.insertAdjacentHTML('beforebegin', rowHTML(cart));
      }
    }

    // count badges should reflect merchandise only
    document.querySelectorAll('[data-cart-item-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (count > 0 && count < 100) el.textContent = count;
      else if (count === 0) el.textContent = '';
    });
  }

  function displayCart(cart) {
    // shallow copy so the theme shows a merchandise-only item count
    var c = Object.assign({}, cart);
    c.item_count = merchCount(cart);
    return c;
  }

  /* ---------- hook into the theme ---------- */
  function wrapThemeFunctions() {
    if (typeof window.buildCart === 'function' && !window.buildCart.__bos) {
      var origBuild = window.buildCart;
      window.buildCart = function (cart, showCart, element) {
        if (busy) return origBuild(displayCart(cart), showCart, element);
        busy = true;
        reconcile(cart).then(function (c) {
          busy = false;
          lastCart = c || cart;
          origBuild(displayCart(lastCart), showCart, element);
        }, function () {
          busy = false;
          lastCart = cart;
          origBuild(displayCart(cart), showCart, element);
        });
      };
      window.buildCart.__bos = true;
    }
    if (typeof window.cartPageUpdate === 'function' && !window.cartPageUpdate.__bos) {
      var origPage = window.cartPageUpdate;
      window.cartPageUpdate = function (cart) {
        reconcile(cart).then(function (c) {
          lastCart = c || cart;
          origPage(lastCart);
        }, function () { lastCart = cart; origPage(cart); });
      };
      window.cartPageUpdate.__bos = true;
    }
  }

  function refreshEverywhere(cart) {
    lastCart = cart;
    if (document.querySelector('[data-cart-wrapper]') && typeof window.cartPageUpdate === 'function') {
      window.cartPageUpdate(cart);
    }
    if (document.querySelector('[data-drawer-body] .yv-cart-drawer') && typeof window.buildCart === 'function') {
      window.buildCart(cart, document.body.classList.contains('yv_side_Drawer_open'));
    } else {
      decorate(cart);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-bos-sp-toggle]')) return;
    var on = t.checked;
    var row = t.closest('[data-bos-sp]');
    if (row) row.classList.add('is-loading');
    setChoice(on)
      .then(function (cart) { return reconcile(cart, on); })
      .then(refreshEverywhere)
      .catch(function () { getCart().then(refreshEverywhere); });
  });

  // re-decorate whenever the theme swaps drawer / cart page markup
  var mo = new MutationObserver(function () {
    if (lastCart) {
      mo.disconnect();
      decorate(lastCart);
      observe();
    }
  });
  function observe() {
    document.querySelectorAll('[data-drawer-body], [data-cart-wrapper]').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
  }

  function init() {
    wrapThemeFunctions();
    observe();
    var before = '';
    getCart().then(function (cart) {
      before = signature(cart);
      return reconcile(cart);
    }).then(function (cart) {
      if (!cart) return;
      if (signature(cart) !== before) {
        // protection was added/changed on load: re-render so totals include it
        refreshEverywhere(cart);
      } else {
        lastCart = cart;
        decorate(cart);
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();
